import EdInputArray from "./src/index.vue";

/* istanbul ignore next */
EdInputArray.install = function (Vue) {
    Vue.component(EdInputArray.name, EdInputArray)
}

export default EdInputArray
